import {addOrRemoveClass, getNextSibling, iterateNodes} from './dom';
import {hoverHandler} from './app';

export default class Toggles {
    constructor(settings) {
        settings.map(setting => {
            let toggles = document.querySelectorAll(setting.selector);
            toggles.forEach(toggle => this.addListeners(toggle, setting));
        });
    }

    addListeners(targetNode, setting) {
        let breakpoint = setting.breakpoint || 0;
        let affectedNode = targetNode;
        let triggers = [].concat(setting.triggers);
        let preventDefault = false;

        if (setting.hasOwnProperty('affectedChild')) {
            affectedNode = targetNode.querySelector(setting.affectedChild);
        }

        if (setting.hasOwnProperty('affectedSibling')) {
            let siblingSelector = setting.affectedSibling;
            affectedNode = getNextSibling(targetNode, siblingSelector);
        }

        if(setting.hasOwnProperty('preventDefault')){
            preventDefault = true;
        }

        triggers.map(trigger => {
            targetNode.addEventListener(trigger, (e) => {
                if(preventDefault === true){
                    e.preventDefault();
                    e.stopPropagation();
                }

                let isMouseoverTrigger = trigger === 'mouseenter' || trigger === 'mouseleave';

                if (isMouseoverTrigger && !hoverHandler.hoverAllowed) {
                    return;
                }

                if (setting.hasOwnProperty('affectedOthers')) {
                    Toggles.toggleMultiple(targetNode, setting.affectedOthers, setting, breakpoint);
                } else {
                    Toggles.toggleClass(affectedNode, setting, breakpoint);
                }

                if (setting.hasOwnProperty('callback') && typeof setting.callback === 'function') {
                    setting.callback(affectedNode, e);
                }
            })
        });
    }

    static toggleMultiple(targetNode, selector, classSetting, breakpoint) {
        let others = document.querySelectorAll(selector);

        others.forEach(node => {
            if (node !== targetNode) {
                Toggles.toggleClass(node, classSetting, breakpoint);
            }
        });
    }

    static toggleClass(toggleNode, classSetting, breakpoint = 0) {
        let willToggle = classSetting.toggleClass || false;

        if (window.innerWidth > breakpoint) {
            if (willToggle) {
                toggleNode.classList.toggle(classSetting.toggleClass);
            }

            addOrRemoveClass(toggleNode, classSetting);
        }
    }
}